import { Routes, Route } from "react-router-dom"
import Navbar from "./Components/Navbar"
import Footer from "./Components/Footer"
import {Heading,Text,Container,Stack} from '@chakra-ui/react';
import Home from "./Components/Home";
import AnimatedCursor from "react-animated-cursor";
import { motion, useTime, useTransform } from "framer-motion";
import Projects from "./Components/Projects";
import Contact from "./Components/Contact";
import Resume from "./Components/Resume";

function App() {
  const time = useTime();
  const rotate = useTransform(time, [0, 6000], [0, 360], { clamp: false });

  return (
    <div style={{display:"fixed"}}>
      <div className="cursor__dot">
        <AnimatedCursor
          innerSize={15}
          outerSize={15}
          color="255, 255 ,255"
          outerAlpha={0.4}
          innerScale={0.7}
          outerScale={5}
        />
      </div>
      
      <Navbar/>
      <Container maxW={'7xl'} py={16} as={Stack} spacing={12}>
      <Routes>
        <Route path="/" element={ <Home/> } />
        <Route path="projects" element={ <Projects/> } />
        <Route path="about" element={ <Contact/> } />
        <Route path="resume" element={ <Resume/> } />
      </Routes>
      </Container>
      {/* <Footer /> */}
      
    </div>
  );
}

export default App;
